import { WeatherDustIcon } from './WeatherDustIcon';

/**
 * author: Andrej Sharapov
 * id CFF329EE-07C3-48E8-B21D-7B31F36875E6
 * name weather-dust
 * version: 7.0.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/weather-dust.svg
 * tags
 * - Weather 
 * - Agriculture 
 */
export const DustStormIcon = WeatherDustIcon;
export default DustStormIcon